// extracted by mini-css-extract-plugin
export default {"controls":"zqg5x","button":"vY-fA","icon":"Kz1H-"};